<div  id="account-info-container">
  <mm-banners *ngIf="achWarningMessage" [bannerText]="[achAuthorizationErrorHeader]" [hyperlink]="noInstructionsErrorLink" [achRedirect]="true" [type]="'error'"></mm-banners>
  <mm-banners *ngIf="(headerState$ | async)?.serviceError || (overviewFailed$ | async)" [bannerText]="[serviceErrorMessage]" [type]="'error'"></mm-banners>
  <mm-account-info-header
    [accountInfo]="accountInfo$ | async"
    (refresh)="refresh($event)"
></mm-account-info-header>
  <div id="cash-info-box">
    <mm-spinner [loading]="headerState$"></mm-spinner>
    <mm-cash-balance-list 
      *ngIf="!isPalAccount" 
      [balances]="cashBalances$ | async" 
      [formerTdaIndicator]="formerTdaIndicator">
    </mm-cash-balance-list>
     <mm-pal-balance-list 
      *ngIf="isPalAccount" 
      [balances]="palBalances$ | async" 
      data-testid="pal-balance-list">
    </mm-pal-balance-list>
    <div *ngIf="shouldShowIraCalc" id="account-info-header-ira-calculator" class="additional-account-info">
      <div class="left-spacer">
        <div class="ira-calculator-title">RMD Current Year</div>
        <div class="ira-calculator-container">
          <a class="ira-calculator-link" (click)="showIraCalcModal()">Inh RMD Calculator</a>
        </div>
      </div>
    </div>
    <div *ngIf="shouldShowTaxWithholding" class="additional-account-info">
      <mm-tax-withholding class="left-spacer" [taxInfo]="taxInfo$ | async" [isNraAccount]="isNraAccount$ | async" [stateCode]="stateCode$ | async"></mm-tax-withholding>
      <a *ngIf="showEditLink()" (click)="editTweClicked()" class="edit-link">Edit</a>
    </div>
    <mm-rmd-age-date class="left-spacer" *ngIf="shouldShowRmdAgeDate" [rmdAgeInfo]="rmdAgeInfo$ | async"></mm-rmd-age-date>
    <mm-eauth class="left-spacer" [eAuthorization$]="eAuthorization$"></mm-eauth>
  </div>
  <edit-account-level-twe-modal [showModal$]="showEditTweUpdateModal" [taxInfo]="taxInfo$ | async" (showTwePopupModal)="showTweModal($event)"></edit-account-level-twe-modal>
  <mm-ira-calculator [showModal]="showIRACalcModal"></mm-ira-calculator>
  <mm-twe-modal [showModal]="showTweModal$" [upcomingTransactions$]="tweUpcomingTransactions$"
    [sloas$]="tweStandingAuth$" [recurringTransactions$]="tweRecurringTransactions$"
    [taxWithholdings$]="taxWithholdings$"
    [tweTableState$]="tweTableState$" [isEditAccountLevelTwe]="isEditAccountLevelTwe">
  </mm-twe-modal>
</div>